<template>
    <div class=" flex justify-content-center flex-wrap m-3 w-100">
        <Message class="mb-2" size="small" severity="warn" icon="pi pi-spin pi-spinner" style="width: 50%;">İşleminiz yapılıyor. Lütfen Bekleyin... </Message>
        <ProgressBar mode="indeterminate" style="height: 6px; width: 60%;"></ProgressBar>
    </div>
</template>

<script>
export default {
    data() { return {}; },
    methods: {},
    mounted() { },
    components: {},
};
</script>